<mbs-form-group class="mb-0 text-sm">
  <mbs-select
    [items]="items()"
    [label]="label()"
    [formControl]="control"
    [virtualScroll]="true"
    [loading]="loading()"
    [bindLabel]="bindLabel"
    [appendTo]="appendTo()"
    [clearable]="clearable()"
    [searchable]="searchable()"
    [placeholder]="placeholder()"
    [isAutoWidth]="true"
    [isCheckboxSelect]="multiple()"
    [isCheckboxOverflow]="multiple()"
    [isCounterShowing]="multiple() && !!counterLabel()"
    [labelForCounter]="counterLabel()"
    [showRequiredMark]="showRequiredMark()"
    [typeahead]="typeahead$"
    [multiple]="multiple()"
    (clear)="clearEvent.emit()"
    (close)="closeEvent.emit()"></mbs-select>
</mbs-form-group>
